/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function MoreHorizontal({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" {...props}><circle cx={12} cy={12} r={1} /><circle cx={19} cy={12} r={1} /><circle cx={5} cy={12} r={1} /></svg>;
}
;